export default __webpack_public_path__ + "static/media/marble.17129e2e.png";